import React from 'react';
import './styles.css';

function DashHome() {
  return <div />;
}

export default DashHome;